"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferBondEditModalButton = OfferBondEditModalButton;
exports.OfferBondAddNewModalButton = OfferBondAddNewModalButton;
exports.OfferBondDeleteModalButton = OfferBondDeleteModalButton;
const react_1 = __importDefault(require("react"));
const GeneralModalButtons_1 = require("../../../../View/Modals/GeneralModalButtons");
const OfferBondModalBody_1 = require("./OfferBondModalBody");
const OfferBondValidationSchema_1 = __importDefault(require("./OfferBondValidationSchema"));
const FilterableTableContext_1 = require("../../../../View/Resultsets/FilterableTable/FilterableTableContext");
function OfferBondEditModalButton({ modalProps: { initialData, repository }, }) {
    const { handleEditObject } = (0, FilterableTableContext_1.useFilterableTableContext)();
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: handleEditObject,
            ModalBodyComponent: OfferBondModalBody_1.OfferBondModalBody,
            modalTitle: "Edycja wadium",
            repository: repository,
            initialData: initialData,
            makeValidationSchema: OfferBondValidationSchema_1.default,
            specialActionRoute: "editOfferBond",
        }, buttonProps: {
            buttonCaption: "Edytuj wadium",
            buttonVariant: "outline-success",
        } }));
}
function OfferBondAddNewModalButton({ modalProps: { initialData, repository }, }) {
    const { handleEditObject } = (0, FilterableTableContext_1.useFilterableTableContext)();
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: handleEditObject,
            ModalBodyComponent: OfferBondModalBody_1.OfferBondModalBody,
            modalTitle: "Dodaj wadium",
            repository: repository,
            initialData: initialData,
            makeValidationSchema: OfferBondValidationSchema_1.default,
            specialActionRoute: "addNewOfferBond",
        }, buttonProps: {
            buttonVariant: "outline-success",
            buttonCaption: "Dodaj wadium",
        } }));
}
function OfferBondDeleteModalButton({ modalProps: { initialData, repository }, }) {
    const { handleEditObject } = (0, FilterableTableContext_1.useFilterableTableContext)();
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: handleEditObject,
            ModalBodyComponent: OfferBondModalBody_1.OfferBondModalBody,
            modalTitle: "Usuń wadium",
            repository: repository,
            initialData: initialData,
            //makeValidationSchema: makeOfferBondValidationSchema,
            specialActionRoute: "deleteOfferBond",
        }, buttonProps: {
            buttonVariant: "outline-danger",
            buttonCaption: "Usuń wadium",
        } }));
}
